<template>
    <svg-icon :width="width" :height="height" :iconColor="iconColor" viewBoxWidth=32 viewBoxHeight=32 strokeWidth=3>
        <polyline points="24 10 13 21 8 16"></polyline>
    </svg-icon>
</template>
<script lang="ts">

import SvgIcon from './SvgIcon.vue';

import { defineComponent } from 'vue';
export default defineComponent({
  props: {
      width: {
          type: [Number, String],
          default: 18
      },
      height: {
          type: [Number, String],
          default: 18
      },
      iconColor: {
          type: String,
          default: 'currentColor'
      }
  },
  components: {
    'svg-icon': SvgIcon,
  },
});

</script>
